<script type="text/javascript">
	import {get,writable} from "svelte/store";
	import moment from "moment";

	import DownloadHelper from "../../Helpers/DownloadHelper";
	import AlertsStore from "../../Alerts/Store";
	import MenuItem from "../FlyoutMenu/MenuItem.svelte";
	import Radio from "@smui/radio";
	import FormField from "@smui/form-field";

	import LoadState from "../../Enums/LoadState";
	import DataFormat from "../../Enums/DataFormat";
	import API from "../../API/API";
	import "./ExportForm.scss";

	import VesselProperty from "../../Models/Enums/VesselProperty"

	import Form from '../Admin/Form.svelte';
	import SpinnerButton from "../Admin/SpinnerButton.svelte"; // TODO: consider moving

	import Button, { Group, GroupItem, Label, Icon } from "@smui/button";
	import Analytics from "../../Analytics/Analytics";
	import AuthStore from "../../Auth/Store";

	let dataType = "alerts";
	let dataFormat = DataFormat.JSON;

	let loadState = writable(LoadState.INIT);
	let useDataFormat = DataFormat.JSON;
	let blobUrl = "";
	let blobFilename = writable("");

	let form = null;
	$: if (form) { form.setReadOnly($loadState !== LoadState.INIT); }

	let selectedVessels = AlertsStore.vesselGroup.selected[VesselProperty.IMO];


	// TODO: definable downsample variable. too much data / too long to process in lambda breaks it tho!
	// TODO: pass selected vessel IMOs here too perhaps. to only download select data.
	let generateDownloadAll = () => {
		generateDownload();
	};
	let generateDownloadSelected = () => {

		let postData = {};
		const imos = get(AlertsStore.vesselGroup.vessels)
							.filter((vessel)=>{ return vessel.selected; })
							.map((vessel) => { return vessel.imo; });
		postData.imos = imos;

		if (dataType == "historic") {
			const mmsis = get(AlertsStore.vesselGroup.vessels)
							.filter((vessel)=>{ return vessel.selected; })
							.map((vessel) => { return vessel.mmsi; });
			postData.mmsis = mmsis;
		}
		generateDownload(postData);
	};
	let generateDownload = (postData = {}) => {
		useDataFormat = dataFormat;
		$loadState = LoadState.LOADING;
		$blobFilename = dataType+"-" + moment(new Date()).format("YYYYMMDD") + "."+useDataFormat.toLowerCase();
		API.post("export?data=" + dataType + "&format=" + useDataFormat.toLowerCase() + "&downsample=300", postData)
			.then((data) => {
				blobUrl = DownloadHelper.asLink(data, useDataFormat);

				$loadState = LoadState.INIT;

				const selector = "#export_data_button";
				const a = document.querySelector(selector);
				console.log(blobUrl, a);
				a.href = blobUrl;
				a.click();

				Analytics.event("export_"+dataType+"_"+useDataFormat.toLowerCase(), { category: "Alerts", username: get(AuthStore.userInfo).username, type:dataType, format: useDataFormat.toLowerCase() });
			});
	}
</script>

<MenuItem title="Export" class="download-menu-item" materialIcon={"save"}>
	<Form bind:this={form} id='export-data-form'>
		<div style="margin-bottom:5px">
			<h3>Data: </h3>
			<FormField>
				<Radio class="download-radio" bind:group={dataType} value='alerts'/>
				<span slot="label">Alerts</span>
			</FormField>
			<FormField>
				<Radio class="download-radio" bind:group={dataType} value='historic'/>
				<span slot="label">Historic Data</span>
			</FormField>
		</div>
		<div style="margin-bottom:5px">
			<h3>Format: </h3>
			<FormField>
				<Radio class="download-radio" bind:group={dataFormat} value='JSON'/>
				<span slot="label">JSON</span>
			</FormField>
			<FormField>
				<Radio class="download-radio" bind:group={dataFormat} value='CSV'/>
				<span slot="label">CSV</span>
			</FormField>
		</div>

		{#if $loadState === LoadState.INIT || $loadState == LoadState.LOADED}
			<Button on:click={generateDownloadAll} color="secondary" variant="unelevated">
				<Icon class="material-icons">save_alt</Icon>
				<Label>
					{#if $selectedVessels.length == 0}
						Download
					{:else}
						Download All
					{/if}
				</Label>
			</Button>

			{#if $selectedVessels.length > 0}
				<Button on:click={generateDownloadSelected} color="secondary" variant="unelevated" style='margin-top:0px;'>
					<Icon class="material-icons">save_alt</Icon>
					<Label>
						Download Selected
					</Label>
				</Button>
			{/if}
		{:else if $loadState === LoadState.LOADING}
			<SpinnerButton />
		{/if}
		<a id="export_data_button" href="javascript:;" download={$blobFilename} style="display:none;">&nbsp;</a>
	</Form>

</MenuItem>
